<template>
  <popup-dialog
    :visible="popup.visible"
    :close-button-visible="true"
    :resizable="true"
    :width="1005"
    class="license-ordering-popup"
    @close="popup.hide()"
  >
    <template #header>
      <div class="popup__label">
        {{ $t('headings.orderSubscription') }}
      </div>
      <p v-if="popup.error && step == 'choose'" class="message-notice p-4 m-4">
        <lucide-icon name="circle-alert" />
        {{ popup.error.message }}
      </p>
    </template>
    <subscription-ordering-form
      ref="form"
      :step-bar="false"
      :same-page="false"
      :style="{ marginTop: step == 'choose' ? '-2rem' : '0' }"
      @update:step="step = $event"
      @done="popup.hide()"
    />
  </popup-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import LucideIcon from "@core/ui/LucideIcon.vue";
import PopupDialog from '@core/ui/PopupDialog.vue';
import SubscriptionOrderingForm from './SubscriptionOrderingForm.vue';
import { useSubscriptionOrderingPopup } from './subscriptionOrderingPopup';

const popup = useSubscriptionOrderingPopup();

watch(() => popup.visible, (visible) => {
  if (visible) {
    step.value = 'choose';
  }
});

let step = ref('choose');
let form = ref<InstanceType<typeof SubscriptionOrderingForm>>();
</script>

<style lang="scss">
.license-ordering-popup {
  border-radius: 0.25em;

  &__header {
    user-select: none;
    display: grid;
    grid-template-columns: 3rem minmax(0, 1fr) 3rem;
    padding-top: 1rem;
  }

  &__heading {
    font-size: 1.75em;
    margin-block: 0.25rem;
    text-align: center;
  }
  &__subheading {
    margin: 0.5rem;
    margin-bottom: 0.75rem;
    font-size: 1.2em;
    text-align: center;
    padding-top: 0.5em;
  }
}
</style>